import { Component, OnInit, Input } from '@angular/core';
import { Product } from 'src/app/models/interface/product/product';
import { CHARACTERISTICS_ORDER } from 'src/app/utils/Constants';

@Component({
  selector: 'app-product-map-data',
  templateUrl: './product-map-data.component.html',
  styleUrls: ['./product-map-data.component.scss']
})
export class ProductMapDataComponent implements OnInit {

  private lastMapping: string;
  @Input() item: Product;
  private _params: any;
  @Input()
  get params(): any {
    return this._params;
  }
  set params(value: any) {
    this._params = value;
    this.ngOnInit();
  }

  type: string;
  info: any;
  constructor() {
  }

  ngOnInit() {
    if (!this.info || this.params.map !== this.lastMapping) {
      this.info = {};
      this.lastMapping = this.params.map;
    }
    this.type = !this.params.type ? 'product' : this.params.type;
    let serviceInfo: any;

    if (this.type === 'cfs') {
      serviceInfo = this.item.cfses.find(service => service.id === +this.params.map);
      serviceInfo.cfsCharValues.sort(function(a, b){
        if(a.name < b.name) { return -1; }
        if(a.name > b.name) { return 1; }
        return 0;
      })
      for (const cfsCharName of CHARACTERISTICS_ORDER) {
        this.info[cfsCharName] = null;
      }
      for (const cfsCharValue of serviceInfo.cfsCharValues) {
        this.info[cfsCharValue.specId] = cfsCharValue.value;
      }
    }
    if (this.type === 'rfs') {
      for (const cfs of this.item.cfses) {
        if (cfs.rfses.find(service => service.id === +this.params.map)) {
          serviceInfo = cfs.rfses.find(service => service.id === +this.params.map);
          break;
        }
      }
      serviceInfo.rfsCharValues.sort(function(a, b){
        if(a.name < b.name) { return -1; }
        if(a.name > b.name) { return 1; }
        return 0;
      })
      for (const rfsCharName of CHARACTERISTICS_ORDER) {
        this.info[rfsCharName] = null;
      }
      for (const rfsCharValue of serviceInfo.rfsCharValues) {
        this.info[rfsCharValue.specId] = rfsCharValue.value;
      }

    }




  }

  returnZero() {
    return 0;
  }

}
